(function () {
  function safeJsonParse(jsonString) {
    if (!jsonString || typeof jsonString !== "string") return { ok: false, value: null };
    try {
      return { ok: true, value: JSON.parse(jsonString) };
    } catch (error) {
      console.warn("[product-function-runner] JSON 解析失败：", error);
      return { ok: false, value: null };
    }
  }

  function resolvePath(root, path) {
    if (!root) return null;
    if (!path || typeof path !== "string") return null;

    var parts = path.split(".").filter(Boolean);
    if (!parts.length) return null;

    var current = root;
    for (var i = 0; i < parts.length; i++) {
      if (current == null) return null;
      current = current[parts[i]];
    }
    return current;
  }

  function setPathValue(root, path, value) {
    if (!root) return false;
    if (!path || typeof path !== "string") return false;

    var parts = path.split(".").filter(Boolean);
    if (!parts.length) return false;

    var current = root;
    for (var i = 0; i < parts.length - 1; i++) {
      var key = parts[i];
      if (!current[key] || typeof current[key] !== "object") current[key] = {};
      current = current[key];
    }

    current[parts[parts.length - 1]] = value;
    return true;
  }

  function getCallable(functionPath) {
    if (!functionPath) return null;

    // 支持 window.fn / window.theme.fn / 以及任意点路径
    var fromWindow = resolvePath(window, functionPath);
    if (typeof fromWindow === "function") return fromWindow;

    // 兼容用户只填 "initQuickShop" 这种：尝试 window.theme 下一级
    var fromTheme = resolvePath(window.theme, functionPath);
    if (typeof fromTheme === "function") return fromTheme;

    return null;
  }

  function runSection(container) {
    if (!container) return;

    var configNode = container.querySelector("[data-product-function-runner-config]");
    if (!configNode) return;

    var parsed = safeJsonParse(configNode.textContent);
    if (!parsed.ok || !parsed.value) return;

    var config = parsed.value;
    var functionList = Array.isArray(config.functions) ? config.functions : [];
    var codeList = Array.isArray(config.codes) ? config.codes : [];

    var ctx = {
      container: container,
      sectionId: config.sectionId || container.getAttribute("data-section-id") || null,
    };

    codeList.forEach(function (item) {
      if (!item || item.enabled !== true) return;
      if (!item.code || typeof item.code !== "string") return;

      var codeText = item.code.trim();
      if (!codeText || codeText === "null") return;

      try {
        var factory = new Function("ctx", codeText);
        var result = factory(ctx);

        var exportPath = typeof item.exportPath === "string" ? item.exportPath.trim() : "";
        if (exportPath) {
          // 支持填写 window.xxx / theme.xxx / 以及任意点路径（默认 root=window）
          var normalized = exportPath.replace(/^window\./, "").trim();
          var root = exportPath.startsWith("theme.") ? window.theme : window;
          var path = exportPath.startsWith("theme.") ? exportPath : normalized;
          if (exportPath.startsWith("theme.") && !window.theme) window.theme = {};
          setPathValue(root, path, result);
        }

        if (item.runAfterDefine === true && typeof result === "function") {
          try {
            result(ctx);
          } catch (error) {
            console.error("[product-function-runner] 自定义函数执行报错：", exportPath || "(anonymous)", error);
          }
        }
      } catch (error) {
        console.error("[product-function-runner] 自定义代码执行报错：", error);
      }
    });

    functionList.forEach(function (item) {
      if (!item || item.enabled !== true) return;
      if (!item.name || typeof item.name !== "string") return;

      var fn = getCallable(item.name);
      if (typeof fn !== "function") {
        console.warn("[product-function-runner] 未找到可执行函数：", item.name);
        return;
      }

      var argsText = typeof item.args === "string" ? item.args.trim() : "";
      var hasArgs = argsText.length > 0 && argsText !== "null";
      if (!hasArgs) {
        try {
          fn(ctx);
        } catch (error) {
          console.error("[product-function-runner] 函数执行报错：", item.name, error);
        }
        return;
      }

      var argsParsed = safeJsonParse(item.args);
      var argsValue = argsParsed.ok ? argsParsed.value : item.args;
      try {
        fn(argsValue, ctx);
      } catch (error) {
        console.error("[product-function-runner] 函数执行报错：", item.name, error);
      }
    });
  }

  function runAll() {
    var nodes = document.querySelectorAll('[data-section-type="product-function-runner"]');
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (el) {
      runSection(el);
    });
  }

  // 首次加载
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll);
  } else {
    runAll();
  }

  // Shopify 设计器：section 动态加载/重渲染
  document.addEventListener("shopify:section:load", function (event) {
    var target = event && event.target;
    if (!target || !target.querySelector) return;
    var container = target.querySelector('[data-section-type="product-function-runner"]');
    if (!container) return;
    runSection(container);
  });
})();

